export const CANCEL_REASON = {
  PROCEDURE_UNCLEAR: 'procedure_unclear',
  PAYMENT_FAILED: 'payment_failed',
  WAITING_TOO_LONG: 'waiting_too_long',
  SCHEDULE_MISMATCH: 'schedule_mismatch',
  IDENTITY_DOCUMENT_DIFFICULT: 'identity_document_difficult',
  PRICE_TOO_HIGH: 'price_too_high',
  PLAN_MISMATCH: 'plan_mismatch',
  NO_LONGER_NEEDED: 'no_longer_needed',
  NO_EFFECT: 'no_effect',
  SIDE_EFFECTS: 'side_effects',
  SYMPTOMS_IMPROVED: 'symptoms_improved',
  COST_BURDEN: 'cost_burden',
  MEDICATION_EXCESS: 'medication_excess',
  SWITCHED_PROVIDER: 'switched_provider',
  DISSATISFIED_SERVICE: 'dissatisfied_service',
  HEALTH_SITUATION_CHANGED: 'health_situation_changed',
  OTHER: 'other',
} as const

export type CancelReasonValue = typeof CANCEL_REASON[keyof typeof CANCEL_REASON]

export type CancelReasonOption = {
  value: CancelReasonValue
  label: string
}

/**
 * Options for the treatments cancel modal (/my-page/treatments).
 * Order matters:「その他」must stay last.
 */
export const CANCEL_REASON_OPTIONS: CancelReasonOption[] = [
  {
    value: CANCEL_REASON.PROCEDURE_UNCLEAR,
    label: '手続きの方法が分からなかった／画面が進まなかった',
  },
  {
    value: CANCEL_REASON.PAYMENT_FAILED,
    label: 'お支払い・決済の手続きできなかった',
  },
  {
    value: CANCEL_REASON.WAITING_TOO_LONG,
    label: '診察・問診の待ち時間が長かった',
  },
  {
    value: CANCEL_REASON.SCHEDULE_MISMATCH,
    label: 'ビデオ診察の日程や環境が合わなかった',
  },
  {
    value: CANCEL_REASON.IDENTITY_DOCUMENT_DIFFICULT,
    label: '本人確認書類の提出が難しかった',
  },
  { value: CANCEL_REASON.PRICE_TOO_HIGH, label: '価格が想定より高かった' },
  {
    value: CANCEL_REASON.PLAN_MISMATCH,
    label: '提示されたお薬・プランが希望と異なった',
  },
  {
    value: CANCEL_REASON.NO_LONGER_NEEDED,
    label: '検討をやめた／必要がなくなった',
  },
  { value: CANCEL_REASON.OTHER, label: 'その他（自由記述）' },
]

/**
 * Options for the purchase-history cancel modal (/my-page/purchase-histories).
 * Order matters:「その他」must stay last.
 */
export const PURCHASE_HISTORY_CANCEL_REASON_OPTIONS: CancelReasonOption[] = [
  { value: CANCEL_REASON.NO_EFFECT, label: '効果を感じられなかった' },
  { value: CANCEL_REASON.SIDE_EFFECTS, label: '副作用や体調の変化があった' },
  {
    value: CANCEL_REASON.SYMPTOMS_IMPROVED,
    label: '症状が改善し、治療を終えたいため',
  },
  { value: CANCEL_REASON.COST_BURDEN, label: '費用の負担が大きい' },
  {
    value: CANCEL_REASON.MEDICATION_EXCESS,
    label: 'お薬が余っている／今は必要ない（再開の可能性がある）',
  },
  {
    value: CANCEL_REASON.SWITCHED_PROVIDER,
    label: '他の医療機関・サービスに変更した',
  },
  {
    value: CANCEL_REASON.DISSATISFIED_SERVICE,
    label: '配送・手続き・サポート対応に不満があった',
  },
  {
    value: CANCEL_REASON.HEALTH_SITUATION_CHANGED,
    label: '妊娠・他のご病気など、状況の変化により服用できなくなった',
  },
  { value: CANCEL_REASON.OTHER, label: 'その他（自由記述）' },
]

export const CANCEL_REASON_TEXT_MAX_LENGTH = 1000
